<div 
  class="custom-route__all-ready"
  [class.hidden]="!isAllReadyViewShown()"
>
  <p class="all-ready__title ci-heading-h4-bold">
    ¡{{ 'Todo listo' | translate }}!
  </p>
  <p class="all-ready__subtitle ci-paragraph-p1-regular">
    {{ 'Disfruta de tu ruta' | translate }}
  </p>
</div>